import React from 'react';
import DocumentStorageList from '../components/documentStorage/DocumentStorageList';

export default function DocumentStorage() {
  return <DocumentStorageList />;
}
